import React, { useEffect, useState } from 'react'
import { DecryptOrderFunction, EncryptOrderFun } from '../features/CryptoJsService'

export const HistoryReport = () => {
    const [transaction, setTransaction] = useState([])
    const [value1, setValue1] = useState()
    const [value2, setValue2] = useState()
    const [loader, setLoader] = useState(false)
    const userData = (sessionStorage.getItem("userData") && DecryptOrderFunction(sessionStorage.getItem("userData")))

    const dateFormater = (date, separator, day) => {
        var day = date.getDate() - day;
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return year + separator + month + separator + day;
    }

    const getHistory = async () => {
        let __POSTDATA =
        {
            sdt: value1,
            edt: value2
        }
        let __HASH = EncryptOrderFun(JSON.stringify(__POSTDATA));
        const res = await fetch(`https://masterapi.fun4club.com/api/admin/masterhistory?Data=${encodeURIComponent(__HASH.toString())}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        })

        const data = await res.json()
        const decrypted = await DecryptOrderFunction(data)
        setTransaction(decrypted);
    }

    const getDate = () => {
        setValue1(document.getElementById("past-date").value);
    }

    const getDate2 = () => {
        setValue2(document.getElementById("new-date").value);
    }

    useEffect(() => {
        const pDate = dateFormater(new Date(), "-", 0)
        document.getElementById("past-date").value = pDate
        document.getElementById("new-date").value = pDate
        setTimeout(() => {
            getDate()
            getDate2()
        }, 100);
    }, [])

    return (
        <div>
            <div>
                {/* {loader && <div style={{ position: "fixed", background: "black", opacity: "0.8", height: "100vh", top: "0", width: "100%", zIndex: "1000" }}>
                    <CommonLoader />
                </div>} */}
                <div className='container-fluid page-body-wrapper'>
                    <div _ngcontent-ebh-c49="" className="main-panel">
                        <div style={{ marginTop: "110px" }} _ngcontent-ebh-c49="" className="content-wrapper">
                            <router-outlet _ngcontent-ebh-c49=""></router-outlet>
                            <app-dashboard _nghost-ebh-c58="">
                                <div _ngcontent-olu-c42="" id="statement-filteraccordion" className="accordion mb-2">
                                    <div _ngcontent-olu-c42="" className="accordion-item flex-1 layout-column border-secondary">
                                        <h2 _ngcontent-olu-c42="" id="statement-filter-head" className="accordion-header">
                                            <button _ngcontent-olu-c42="" type="button" data-bs-toggle="collapse" data-bs-target="#statement-filter-one" aria-expanded="true" aria-controls="statement-filter-one" className="accordion-button bg-secondary btn btn-secondary p-1 small fw-semibold text-black text-start w-100">
                                                <span _ngcontent-olu-c42="" className="ps-1 text-light small">Account Statement</span>
                                            </button>
                                        </h2>
                                        <div _ngcontent-olu-c42="" id="statement-filter-one" aria-labelledby="statement-filter-head" data-bs-parent="#statement-filteraccordion" className="accordion-collapse flex-1 collapse show overflow-auto">
                                            <div _ngcontent-olu-c42="" className="accordion-body px-1 py-2">
                                                <div _ngcontent-olu-c42="" className="row m-0">
                                                    <div _ngcontent-olu-c42="" className="col-auto">
                                                        <div _ngcontent-olu-c42="" className="input-group mb-3">
                                                            <span _ngcontent-olu-c42="" className="input-group-text rounded-0">
                                                                <i _ngcontent-olu-c42="" className="far fa-calendar-alt"></i>
                                                            </span>
                                                            <input id='past-date' onChange={getDate} _ngcontent-olu-c42="" type="date" className="form-control rounded-0 text-uppercase ng-untouched ng-pristine ng-valid" />
                                                        </div>
                                                    </div>
                                                    <div _ngcontent-olu-c42="" className="col-auto">
                                                        <div _ngcontent-olu-c42="" className="input-group mb-3">
                                                            <span _ngcontent-olu-c42="" className="input-group-text rounded-0">
                                                                <i _ngcontent-olu-c42="" className="far fa-calendar-alt"></i>
                                                            </span>
                                                            <input id='new-date' onChange={getDate2} _ngcontent-olu-c42="" type="date" className="form-control rounded-0 text-uppercase ng-untouched ng-pristine ng-valid" />
                                                        </div>
                                                    </div>
                                                    <div _ngcontent-olu-c42="" className="col-auto m-1 px-3">
                                                        <button onClick={() => getHistory()} _ngcontent-olu-c42="" className="btn btn-login">Get Statement</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div _ngcontent-olu-c42="" className="accordion-item flex-1 layout-column border-secondary">
                                        <h2 _ngcontent-olu-c42="" id="statement-filter-head" className="accordion-header">
                                            <button _ngcontent-olu-c42="" type="button" data-bs-toggle="collapse" data-bs-target="#statement-filter-one" aria-expanded="true" aria-controls="statement-filter-one" className="accordion-button bg-secondary btn btn-secondary p-1 small fw-semibold text-black text-start w-100">
                                                <span _ngcontent-olu-c42="" className="ps-1 text-light small">Filters</span>
                                            </button>
                                        </h2>
                                        <div _ngcontent-olu-c42="" id="statement-filter-one" aria-labelledby="statement-filter-head" data-bs-parent="#statement-filteraccordion" className="accordion-collapse flex-1 collapse show overflow-auto">
                                            <div _ngcontent-olu-c42="" className="accordion-body px-1 py-2">
                                                <div _ngcontent-olu-c42="" className="row m-0">
                                                    <div _ngcontent-olu-c42="" className="col-auto d-flex flex-column">
                                                        <label htmlFor="">SportsName</label>
                                                        <input type="text" placeholder='Enter sports name for filter' className='form-control' />
                                                    </div>
                                                    <div _ngcontent-olu-c42="" className="col-auto d-flex flex-column">
                                                        <label htmlFor="">EventName</label>
                                                        <input type="text" placeholder='Enter event name for filter' className='form-control' />
                                                    </div>
                                                    <div _ngcontent-olu-c42="" className="col-auto d-flex flex-column">
                                                        <label htmlFor="">SportsId</label>
                                                        <input type="text" placeholder='Enter Sports ID for filter' className='form-control' />
                                                    </div>
                                                    <div _ngcontent-olu-c42="" className="col-auto d-flex flex-column">
                                                        <label htmlFor="">MarketName</label>
                                                        <input type="text" placeholder='Enter Market Name for filter' className='form-control' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div _ngcontent-olu-c42="" id="statement-detailaccordion" className="accordion">
                                    <div _ngcontent-olu-c42="" className="accordion-item flex-1 layout-column border-secondary">
                                        <h2 _ngcontent-olu-c42="" id="statement-detail-head" className="accordion-header">
                                            <button _ngcontent-olu-c42="" type="button" data-bs-toggle="collapse" data-bs-target="#statement-detail-one" aria-expanded="true" aria-controls="statement-detail-one" className="accordion-button bg-secondary btn btn-secondary p-1 small fw-semibold text-black text-start w-100">
                                                <span _ngcontent-olu-c42="" className="ps-1 text-light small">Statement Details</span>
                                            </button>
                                        </h2>
                                        <div _ngcontent-olu-c42="" id="statement-detail-one" aria-labelledby="statement-detail-head" data-bs-parent="#statement-detailaccordion" className="accordion-collapse flex-1 collapse show overflow-auto">
                                            <div _ngcontent-olu-c42="" className="accordion-body px-1 py-2">
                                                <div _ngcontent-olu-c42="" className="table-responsive">
                                                    <table _ngcontent-olu-c42="" className="table table-bordered text-nowrap">
                                                        <thead _ngcontent-olu-c42="" className="table-dark">
                                                            <tr _ngcontent-olu-c42="">
                                                                <th _ngcontent-olu-c42="">Sr. No.</th>
                                                                <th _ngcontent-olu-c42="">Date</th>
                                                                <th _ngcontent-olu-c42="">Dr/Cr</th>
                                                                <th _ngcontent-olu-c42="">Balance</th>
                                                                <th _ngcontent-olu-c42="">Type</th>
                                                                <th _ngcontent-olu-c42="">Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody _ngcontent-olu-c42="">

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </app-dashboard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
